import { defineComponent as _defineComponent } from 'vue'

import { Competition, FinalResultTeamReadingStats } from '@ilteducation/competition-referee-types';
import axios from 'axios';
import Papa from 'papaparse';

type Props = {
  id?: string;
  title: string;
  item: Competition;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Show',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string;
  title: string;
  item: Competition;
}



const exportRankings = async () => {
  const now = new Date();
  const competitionId = props.item.id;
  const fileName = `rankings-${props.item.name}-${now.toDateString()}.csv`.replace(' ', '-');
  const rankingsResponse = await axios.get(
    `${process.env.VUE_APP_COMPETITION_REFEREE_API_URL}rankings/export/${competitionId}`,
  );
  const rankings = rankingsResponse.data as FinalResultTeamReadingStats[];

  const columns: (keyof FinalResultTeamReadingStats)[] = [
    'ranking',
    'teamName',
    'totalReadingTimeMinutes',
    'averageReadingTimeMinutes',
    'grade',
    'city',
    'schoolName',
    'numberOfMembers',
    'contact',
    'teamOwnerId'
  ];
  const csv = Papa.unparse(rankings, { header: true, columns });

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', fileName);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

return { __sfc: true,props, exportRankings }
}

})